import { render, staticRenderFns } from "./inner-loading.vue?vue&type=template&id=2b1df6ea&"
import script from "./inner-loading.vue?vue&type=script&lang=js&"
export * from "./inner-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QInnerLoading,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QInnerLoading,QSpinnerIos})
